import $ from "$";
import event from "event";

function Overlay(elem, opt) {
  const self = this;
  this.opt = opt || {};
  this.$el = elem || $(`<div class='${this.opt.class || "overlay"}'></div>`);
  this.$el.on("touchend", function(e) {
    e.preventDefault();
    self.hide();
    self.emit("tap");
  });
  this.appended = false;
}

Overlay.prototype.click = function(handler) {
  this.$el.click(handler);
};

Overlay.prototype.show = function() {
  var $body = $("body");
  var self = this;
  if (!this.appended) {
    this.$el.appendTo($body).hide();
    this.appended = true;
  }
  this.$el.show();
  this.$el.css("opacity", 1);
  self.$el.css("display", "block");
};

Overlay.prototype.remove = function() {
  this.$el.remove();
};

Overlay.prototype.hide = function() {
  var self = this;
  if (this.$el) {
    this.$el.css("opacity", 0);
    this.$el.css("display", "none");
    self.$el.hide();
  }
};

event.mixin(Overlay);

let wrapped = {
  _overlay() {
    if (!this._instance) {
      this._instance = new Overlay();
    }
    return this._instance;
  },
  show() {
    this._overlay().show();
  },
  hide() {
    this._overlay().hide();
  },
  getInstance() {
    return this._overlay();
  },
};

Overlay.wrapped = wrapped;

export default Overlay;



// WEBPACK FOOTER //
// ./src/mods/overlay.js